type BrowserLocation = Pick<Location, "protocol" | "host" | "pathname" | "search" | "hash">;

export function canonicalHttpsUrl(location: BrowserLocation, production: boolean): string | null {
  if (!production || location.protocol !== "http:") return null;
  return `https://${location.host}${location.pathname}${location.search}${location.hash}`;
}
